<script>
  import * as d3 from 'd3';

  import { formatEther } from 'viem';

  import { compressString } from '../../utils.js';

  import pie from './pie.js';

  export let data;
  export let conf;

  const valueProcesses = {
    weis: d => Number(d[value || 'value'])
  }

  const keyReprs = {
    wallet: d => compressString(d.data[key || 'name'], 4)
  }

  const valueReprs = {
    value: d => new Intl.NumberFormat('default', { maximumSignificantDigits: 6 }).format(d.data[value || 'value']),
    valueEther: d => new Intl.NumberFormat('default', { maximumSignificantDigits: 6 }).format(formatEther(d.data[value || 'value'].toString()))
  }

  let container
  $: container || data, render();

  const render = () => {
    if (container && data) {
      container.replaceChildren();
      container.append(pie(d3, data, conf));
    }
  }
</script>

<div class={ $$props.class } class:pie={ true } class:chart={ true } bind:this={ container }></div>